module.exports = __webpack_public_path__ + "themes/mf/img/prize-2@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-2@2x.png
// module id = 89
// module chunks = 3